import { fetchConToken } from '../helpers/fetch';

export async function loadBankData(endpoint, signal) {
    const response = await fetchConToken(`bancos/${endpoint}`, undefined, 'GET', {signal});
    if (!response.headers.get('content-type')?.includes('application/json')) throw new Error('Bancos no está disponible. Verifica que el backend esté actualizado.');
    const body = await response.json();
    if (!response.ok || !body.ok || !body.data) throw new Error(body.msg || 'No se pudo cargar la información bancaria.');
    return body.data;
}
